export default function breakToWords(text?: string | null): string {
    text = text ?? '';
    text = text.replace(/[^ a-zA-Z0-9_-]/g, '');
    text = text.replace(/([a-z])([A-Z])/g, '$1 $2');
    text = text.replace(/([A-Z])([A-Z])([a-z])/g, '$1 $2$3');
    return text;
}
